import React from 'react';

import { type Table } from '@tanstack/react-table';

import { DataTableControls } from 'src/registry/components/table';

import type { DataTableNewEntryProps, DataTableSemantics } from 'src/registry/components/table/types';

export type DataTableControlsProps<TData> = {
    table: Table<TData>;
    semantics?: DataTableSemantics;
    newEntryComponent?: React.FC<DataTableNewEntryProps<TData>>;
    isLoading?: boolean;
    isError?: boolean;
    canRenderSearch?: boolean;
    canRenderViewOptions?: boolean;
    canRenderFilters?: boolean;
};
export function CustomDataTableControls(children: React.ReactNode) {
    return function dataTableControls<TData>({
        table,
        semantics,
        isError,
        newEntryComponent: NewEntryComponent,
        canRenderSearch,
        canRenderViewOptions,
        canRenderFilters,
    }: DataTableControlsProps<TData>) {
        return (
            <DataTableControls
                table={table}
                semantics={semantics}
                isError={isError}
                canRenderFilters={canRenderFilters}
                canRenderSearch={canRenderSearch}
                newEntryComponent={NewEntryComponent}
                canRenderViewOptions={canRenderViewOptions}
            >
                {children}
            </DataTableControls>
        );
    };
}
